module.exports = __webpack_public_path__ + "img/icb-leo-Adv-m@2x.3fa01e59.png";